// Module
var code = "<div> <div class=\"availabilities-day-title\"> <div class=\"availabilities-day-name\"><span class=\"day-name\"></span></div> <div class=\"availabilities-day-date\"><span class=\"day-number\"></span></div> </div> </div>";
// Exports
module.exports = code;